import { IressButton, IressIcon, IressText } from '@iress-oss/ids-components';
import './PageError.css';

interface PageErrorProps {
  /** Retry the specific content that failed. Never a page/browser reload. */
  onRetry: () => void;
}

/**
 * The single, consistent page-level error state: an icon, the message
 * "Something went wrong. Please try again.", and a Refresh button that
 * invokes {@link PageErrorProps.onRetry}. Presentational only — the caller
 * owns what "retry" means (re-fetch history, re-send a query, etc.).
 *
 * Mounted at two levels by the caller: shell-level (below the header, hiding
 * the tab bar) for an open-Porter failure, or pane-level (inside a pane body,
 * tab bar stays) for History / Chat failures.
 */
export function PageError({ onRetry }: Readonly<PageErrorProps>) {
  return (
    <div className="porter-page-error" role="alert">
      <span className="porter-page-error__icon">
        <IressIcon name="error" textStyle="typography.body.md.strong" />
      </span>
      <IressText
        textAlign="center"
        className="porter-page-error__text"
        textStyle="typography.body.md.regular"
      >
        Something went wrong. Please try again.
      </IressText>
      <IressButton
        mode="secondary"
        onClick={onRetry}
        textStyle="typography.body.md.strong"
      >
        <IressIcon name="refresh" textStyle="typography.body.md.strong" />
        Refresh
      </IressButton>
    </div>
  );
}
